<template>
  <span>
    <router-link :to="'/tasks/resources/' + id" v-if="userHasReadPermission(PermissionTypes.TaskPermissionTypes.taskConfig)" :target="target" :class="{'router-link-newtab': newTab}">
      {{name}}
    </router-link>
    <span v-else>
      {{name}}
    </span>
  </span>
</template>

<script>
export default {
  name: 'LinkResource',
  props: {
    id: Number,
    name: String,
    newTab: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    target() {
      if(this.newTab)
        return '_blank'

      return '_self'
    }
  }
}
</script>
